import React from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import {
  // getCurtainRailHexColour,
  getHexColorCode,
  getHoneycombRailHexColour,
  getRollerHexColour,
} from '../../../helpers/getHexColorCode';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { getRailColourOptions } from '../../../helpers/railColour';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorColour } from '../../Common/Selector';
// import { SectionContent } from './SectionContent';

type OnClick = (
  railColour: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (railColour, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      railColour,
    },
  });
};

const Wrapper = styled.div`
  width: 100%;
  max-width: 300px;

  .keen-slider {
    justify-content: center;
  }

  .keen-slider-selector__slide {
      margin: 0 5px;
      min-width: 45px !important;
      max-width: 45px !important;
  }
  @media (min-width: 1441px) {
    padding-top: 30px;
  }
  @media (max-width: 1440px) {
    width: 100%;
    max-width: 100%;
  }
`;

// type OnMouseOver = (
//   colour: string,
//   send: (event: ProductBuilderMachineEvent) => void,
// ) => () => void;

// const onMouseOver: OnMouseOver = (railColour, send) => () =>
//   send({
//     type: 'UPDATE_CUSTOM',
//     custom: {
//       railColour,
//     },
//   });

export const RailColour = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    custom: { railColour },
  } = state.context;
  const railColourOptions = getRailColourOptions(state.context);
  const productType = getBaseProductType(state.context);

  const getHexColorCodeByProductType =
    productType === 'Honeycomb'
      ? getHoneycombRailHexColour
      : productType === 'Roller Blind'
      ? getRollerHexColour
      : getHexColorCode;

  if (isCurrentState('railColour', state) && railColourOptions.length === 0) {
    throwError(state);
  }

  return (
    <Wrapper>
      <Heading>Rail colour</Heading>
      <Selector isSlider={true} isColorPicker={true}>
        {railColourOptions.map(option => {
          return (
            <SelectorColour
              isSelected={option === railColour}
              onClick={onClick(option, send)}
              key={option}
              colourName={option}
              colourCode={getHexColorCodeByProductType(option)}
              colourSwatch={''}
            />
          );
        })}
      </Selector>
      <Caption>{railColour}</Caption>
    </Wrapper>
  );
};
